// public-site/src/typography.js
// Copied from the staff app's src/config/typography.js for visual consistency.
// Typography styles are a plain config object (no dual-file-sync rule applies).

const typography = {
  fonts: {
    display: "'EB Garamond', Georgia, serif",
    body: "'Host Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "'IBM Plex Mono', 'SF Mono', 'Consolas', 'Monaco', monospace",
  },

  pageTitle: {
    fontFamily: "'EB Garamond', Georgia, serif",
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },

  sectionHeader: {
    fontFamily: "'EB Garamond', Georgia, serif",
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: 1.3,
    letterSpacing: '0',
  },

  cardTitle: {
    fontFamily: "'EB Garamond', Georgia, serif",
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: 1.3,
    letterSpacing: '0',
  },

  body: {
    fontFamily: "'Host Grotesk', -apple-system, sans-serif",
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: '0',
  },

  bodySecondary: {
    fontFamily: "'Host Grotesk', -apple-system, sans-serif",
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0',
  },

  label: {
    fontFamily: "'Host Grotesk', -apple-system, sans-serif",
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
  },

  input: {
    fontFamily: "'Host Grotesk', -apple-system, sans-serif",
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 1.4,
    letterSpacing: '0',
  },

  error: {
    fontFamily: "'Host Grotesk', -apple-system, sans-serif",
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: '0',
  },

  buttonLg: {
    fontFamily: "'Host Grotesk', -apple-system, sans-serif",
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: 1,
    letterSpacing: '0.02em',
  },

  transactionId: {
    fontFamily: "'IBM Plex Mono', 'Consolas', monospace",
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: '0',
  },

  currencyHero: {
    fontFamily: "'EB Garamond', Georgia, serif",
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: 1.1,
    letterSpacing: '-0.02em',
  },
};

export default typography;
